import Expenditure from "@/types/expenditure/expenditure"

export default class Tracking {
  public constructor (init?:Partial<Tracking>) {
    Object.assign(this, init)
  }

  public id: string | null = null;
  public startingTime: number | null = null;
  public endTime: number | null = null;
  public projectId: string | null = null;
  public making: string | number | null = null;
  public task: string | null = null;
  public expenditures: Expenditure[] | null = null;
  public totalExpenditurePrice: number | null = null;
}
